<template>
  <el-dialog title="楼长信息" :visible.sync="visible" width="30%" @close="closeDialog">
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="姓名" prop="repairTypeName">
            <el-input v-model="formData.repairTypeName" placeholder="请输入姓名" />
          </el-form-item>
        </el-col>
      </el-row>
       <el-form-item :label="$t('propertyRightRegistration.add.floor')" prop="floorId">
            <el-select v-model="formData.floorId" :placeholder="$t('propertyRightRegistration.add.floorPlaceholder')"
              style="width:100%">
              <el-option v-for="item in floors" :key="item.floorId"
                :label="`${item.floorNum}${$t('propertyRightRegistration.add.floorUnit')}`" :value="item.floorId" />
            </el-select>
          </el-form-item>
      <el-row>
        <el-col :span="24">
          <el-form-item label="手机号" prop="repairTypeName">
            <el-input v-model="formData.repairTypeName" placeholder="请输入手机号" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>  
        <el-col :span="24">
          <el-form-item label="房号" prop="idNumber">
            <el-input v-model="formData.idNumber" placeholder="请输入房号" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>  
        <el-col :span="24">
         <el-form-item label="性别" prop="isfy">
            <el-radio-group v-model="formData.statusCd">
            <el-radio label="0">男</el-radio>
            <el-radio label="1">女</el-radio>
            </el-radio-group>
        </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="人像照片" prop="idCardPhotos">
            <upload-image-url ref="idCardUpload" :image-count="1" @notifyUploadCoverImage="handleIdCardChange" />
            <p class="tip">请上传人像照片</p>
          </el-form-item>
        </el-col>
      </el-row>
      
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('gridWorker.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('gridWorker.submit') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveRepairSetting } from '@/api/work/repairSettingApi'
import { getCommunityId } from '@/api/community/communityApi'
import { getFloors} from '@/api/room/roomApi'
import UploadImageUrl from '@/components/upload/UploadImageUrl'

export default {
  name: 'AddGridWorker',
  components: {
    UploadImageUrl
  },
  data() {
    return {
      floors: [],
      visible: false, 
      formData: {
        repairTypeName: '',
        repairWay: '200',
        repairSettingType: '200',
        remark: '',
        publicArea: 'F',
        payFeeFlag: 'F',
        returnVisitFlag: '003',
        isShow: 'Y',
        doTime: 24,
        warningTime: 30,
        notifyWay: 'WECHAT'
      },
      rules: {
        repairTypeName: [
          { required: true, message: this.$t('gridWorker.namePlaceholder'), trigger: 'blur' },
        ],
        repairSettingType: [
          { required: true, message: this.$t('gridWorker.settingTypeRequired'), trigger: 'change' }
        ],
        repairWay: [
          { required: true, message: this.$t('gridWorker.dispatchMethodRequired'), trigger: 'change' }
        ],
        publicArea: [
          { required: true, message: this.$t('gridWorker.publicAreaRequired'), trigger: 'change' }
        ],
        isShow: [
          { required: true, message: this.$t('gridWorker.ownerDisplayRequired'), trigger: 'change' }
        ],
        notifyWay: [
          { required: true, message: this.$t('gridWorker.notificationMethodRequired'), trigger: 'change' }
        ],  
        returnVisitFlag: [
          { required: true, message: this.$t('gridWorker.returnVisitRequired'), trigger: 'change' }
        ],
        doTime: [
          { required: true, message: this.$t('gridWorker.processingTimeRequired'), trigger: 'blur' },
          { type: 'number', min: 1, message: this.$t('gridWorker.processingTimeMin'), trigger: 'blur' }
        ],
        warningTime: [
          { required: true, message: this.$t('gridWorker.timeoutWarningRequired'), trigger: 'blur' },
          { type: 'number', min: 1, message: this.$t('gridWorker.timeoutWarningMin'), trigger: 'blur' }
        ],
        remark: [
          { max: 500, message: this.$t('gridWorker.remarkMaxLength'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.getFloors();
      this.visible = true;

    },

    closeDialog() {
      this.visible = false
      this.resetForm()
    },

    resetForm() {
      this.$refs.form.resetFields()
      this.formData = {
        repairTypeName: '',
        repairWay: '200',
        repairSettingType: '200',
        remark: '',
        publicArea: 'F',
        payFeeFlag: 'F',
        returnVisitFlag: '003',
        isShow: 'Y',
        doTime: 24,
        warningTime: 30,
        notifyWay: 'WECHAT',
        communityId: getCommunityId()
      }
    },

    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await saveRepairSetting(this.formData)
            this.$message.success(this.$t('common.operationSuccess'))
            this.$emit('success')
            this.closeDialog()
          } catch (error) {
            console.error('添加报修设置失败:', error)
            this.$message.error(this.$t('repairSetting.addFailed'))
          }
        }
      })
    },
    async getFloors() {
      try {
        const params = {
          communityId:getCommunityId(),
          page: 1,
          row: 50
        }
        const data = await getFloors(params)
        this.floors = data.apiFloorDataVoList || []
      } catch (error) {
        console.error('获取楼栋数据失败:', error)
      }
    },
     handleIdCardChange(photos) {
        console.log(photos)
      this.formData.idCardPhotos = photos
    },
  }
}
</script>